module.exports = __webpack_public_path__ + "img/product_82.30d32fe.webp";